import { useState, useEffect } from 'react'
import { Cascader } from 'antd'
import service from '../@services'
import Item from 'antd/lib/list/Item'
export default function CategorySelect(props) {
  const {
    style = {},
    disabled = false,
    onChange = () => {},
    categoryId = '',
    changeOnSelect = false
  } = props
  const [categoryOptions, setCategoryOptions] = useState([])
  const [defaultValue, setDefaultValue] = useState()
  const [node, setCheckedNode] = useState()
  useEffect(() => {
    service.common.getCategoryTree().then((data = []) => {
      setCategoryOptions(data)
      //setDefaultValue(['30','3001','300101','30010101'])
    })
    return () => {}
  }, [])
  useEffect(() => {
    getSelectedCategory(categoryOptions)
  }, [categoryOptions])
  useEffect(() => {
    const parents = findAllParent(node, categoryOptions)
    if (parents)
      setDefaultValue(
        [node, ...findAllParent(node, categoryOptions)]
          .map(item => item.categoryCode)
          .reverse()
      )
  }, [node])
  const findAllParent = (node, tree, parentNodes = [], index = 0) => {
    if (!node || !node['parentCode']) {
      return
    }
    findParent(node, parentNodes, tree)
    let parentNode = parentNodes[index]
    findAllParent(parentNode, tree, parentNodes, ++index)
    return parentNodes
  }
  const findParent = (node, parentNodes, tree) => {
    for (let i = 0; i < tree.length; i++) {
      let item = tree[i]
      if (item['categoryCode'] === node['parentCode']) {
        parentNodes.push(item)
        return
      }
      if (item.children && item.children.length > 0) {
        findParent(node, parentNodes, item.children)
      }
    }
  }
  const getSelectedCategory = list => {
    list.forEach(item => {
      if (item.id == categoryId) {
        setCheckedNode(item)
      } else {
        if (item.children && item.children.length)
          getSelectedCategory(item.children)
      }
    })
  }
  return (
    <Cascader
      defaultValue={defaultValue}
      key={defaultValue}
      style={style}
      disabled={disabled}
      changeOnSelect={changeOnSelect}
      options={categoryOptions}
      fieldNames={{
        label: 'categoryName',
        value: 'categoryCode',
        children: 'children'
      }}
      onChange={onChange}
      placeholder='请选择'
      getPopupContainer={triggerNode => triggerNode.parentNode || document.body}
    />
  )
}
